<div class="col input-group flex-nowrap" id="add-filter-button" (click)="openGlobalFilterSideBar($event, 'universal_filter')">
    <label role="button" class="form-control text-center add-filter-button" [class.active]="(activeRoute != 'huddle' && isUniversalFilterActive ) || (activeRoute == 'huddle' && isHuddleFilterActive )"
        placeholder="Section 3" aria-label="Username" *ngIf="isAddfilterBtnEnabled" aria-describedby="addon-wrapping">
        <img src="assets/images/filter-outline.svg" class="add-filter-icon" />
        <img src="assets/images/filter-fill.svg" class="add-filter-active-icon" />
        <span class="ml-10 add-filter-text">Filter</span>
    </label>
</div>